import {
  PromoEngineApiFactory,
  GetPromoEnginePromotionList,
  InlineResponse2007,
  InlineResponse2006,
  InlineResponse20014,
} from '@/api/api'
import { AxiosPromise } from 'axios'

/* const DATA_CATEGORIES = [
  {
    id: 64,
    name: 'Promo Engine Intrend 3.0 Italia Wave 1-1.5 UAT',
    start_date: '2024-01-01',
    end_date: '2025-12-31',
    lifecycle: 'RUNNING',
    priority: 1,
    active: 1,
    description: 'Promo Engine Intrend 3.0 Italia Wave 1-1.5 UAT',
    tags: '#uat#w1#w1.5#in3',
    cg: {
      legal_entity: 'M013',
      shop_sign: 'DT',
    },
    last_update: '2024-09-24T13:49:03+0000',
    promotions: [
      {
        id: 383,
        id_campaign: 64,
        name: '3 AWS Promo Item Selection',
        start_date: '2024-01-01',
        end_date: '2025-12-31',
        lifecycle: 'RUNNING',
        priority: 1,
        combinability: 'ALWAYS',
        effect_type: 'DISCOUNT',
        color_code: '#99008C',
        title: 'Promo Item Selection',
        description: '25% su una selezione di capi',
        document: '',
        effects: [
          {
            limit: 3,
            name: 'Sconto Item 30% max3',
            application_type: 'AUTO',
            selection: 'none',
            applications: 1,
            value_type: 'PERCENTAGE',
            effect_value: {
              type: 'single',
              value: '-25',
            },
          },
        ],
        last_update: '2024-09-26T07:36:10+0000',
      },
    ],
  },
  {
    id: 117,
    name: 'Promo Engine Intrend Italia Wave 1.5 UAT',
    start_date: '2024-01-01',
    end_date: '2025-12-31',
    lifecycle: 'RUNNING',
    priority: 3,
    active: 1,
    description: 'Promo Engine Intrend Italia Wave 1.5 UAT',
    tags: '#uat#w1.5',
    cg: {
      legal_entity: 'M013',
      shop_sign: 'DT',
    },
    last_update: '2024-08-30T08:48:22+0000',
    promotions: [
      {
        id: 384,
        id_campaign: 117,
        name: 'BS Promo Item A Giugno 2024',
        start_date: '2024-01-01',
        end_date: '2025-12-31',
        lifecycle: 'RUNNING',
        priority: 1,
        combinability: 'ALWAYS',
        effect_type: 'DISCOUNT',
        color_code: '#2FB375',
        title: 'Nuovi Look per te',
        description: '-20% su tutto se acquisti una Camicia, blus, T-shirt',
        document:
          'https://docs.google.com/presentation/d/1A2g7tVCSTfHdNz94cOeuU8I8ONKXYYKHdvkT1IrALmU/edit#slide=id.g28b4f31f4ae_0_3',
        effects: [
          {
            limit: 0,
            name: 'Sconto Cart 20%',
            application_type: 'AUTO',
            selection: 'none',
            applications: 1,
            value_type: 'PERCENTAGE',
            effect_value: {
              type: 'single',
              value: '-20',
            },
          },
        ],
        last_update: '2024-09-26T07:36:10+0000',
      },
      {
        id: 389,
        id_campaign: 117,
        name: 'BS Promo Item B Giugno 2024',
        start_date: '2024-01-01',
        end_date: '2025-12-31',
        lifecycle: 'DRAFT',
        priority: 2,
        combinability: 'EXCLUSIVE',
        effect_type: 'DISCOUNT',
        color_code: '#2FB375',
        title: 'Promo Item B Maggio',
        description: '20% su tutto se acquisti un abito o una tuta',
        document: '',
        effects: [
          {
            limit: 0,
            name: 'Sconto Cart 20%',
            application_type: 'AUTO',
            selection: 'none',
            applications: 1,
            value_type: 'PERCENTAGE',
            effect_value: {
              type: 'single',
              value: '-20',
            },
          },
        ],
        last_update: '2024-09-26T07:31:20+0000',
      },
    ],
  },
] */

const DATA_PROMOTIONS_RESP = [
  {
    id: 383,
    id_campaign: 64,
    name: '3 AWS Promo Item Selection',
    start_date: '2024-01-01',
    end_date: '2025-12-31',
    lifecycle: 'RUNNING',
    priority: 100001,
    combinability: 'ALWAYS',
    effect_type: 'DISCOUNT',
    color_code: '#99008C',
    title: 'Promo Item Selection',
    description: '25% su una selezione di capi',
    document: '',
    effects: [
      {
        limit: 3,
        name: 'Sconto Item 30% max3',
        application_type: 'AUTO',
        selection: 'none',
        applications: 1,
        value_type: 'PERCENTAGE',
        effect_value: {
          type: 'single',
          value: '-25',
        },
      },
    ],
    last_update: '2024-10-14T12:52:40+0000',
    campagna: 'Promo Engine Intrend 3.0 Italia Wave 1-1.5 UAT',
    priority_idx: 1,
  },
  {
    id: 384,
    id_campaign: 117,
    name: 'BS Promo Item A Giugno 2024',
    start_date: '2024-01-01',
    end_date: '2025-12-31',
    lifecycle: 'RUNNING',
    priority: 300001,
    combinability: 'ALWAYS',
    effect_type: 'DISCOUNT',
    color_code: '#2FB375',
    title: 'Nuovi Look per te',
    description: '-20% su tutto se acquisti una Camicia, blus, T-shirt',
    document:
      'https://docs.google.com/presentation/d/1A2g7tVCSTfHdNz94cOeuU8I8ONKXYYKHdvkT1IrALmU/edit#slide=id.g28b4f31f4ae_0_3',
    effects: [
      {
        limit: 0,
        name: 'Sconto Cart 20%',
        application_type: 'AUTO',
        selection: 'none',
        applications: 1,
        value_type: 'PERCENTAGE',
        effect_value: {
          type: 'single',
          value: '-20',
        },
      },
    ],
    last_update: '2024-10-14T12:52:40+0000',
    campagna: 'Promo Engine Intrend Italia Wave 1.5 UAT',
    priority_idx: 2,
  },
]

const DATA_CAMPAIGNS_RESP = [
  {
    id: 202,
    name: 'Campagna di test per stampe fiscali',
    start_date: '2025-02-20',
    end_date: '2025-09-30',
    lifecycle: 'RUNNING',
    priority: 4,
    active: 1,
    description: '',
    tags: '',
    cg: {
      legal_entity: 'M013',
      shop_sign: 'DT',
    },
    last_update: '2025-09-26T22:01:02+0000',
    promotions: [
      {
        id: 736,
        id_campaign: 202,
        name: 'Test Steps',
        start_date: '2025-09-02',
        end_date: '2025-09-30',
        lifecycle: 'RUNNING',
        priority: 5,
        combinability: 'ALWAYS',
        effect_type: 'FIDELITY',
        color_code: '#000000',
        title: 'Set permanent points',
        description: 'PERMANENT STEPS',
        document: '',
        effects: [
          {
            limit: 0,
            name: 'Effect Steps',
            application_type: 'AUTO',
            selection: 'none',
            applications: 1,
            value_type: 'HOP_STEP_POINTS',
            start_date: null,
            end_date: null,
            days_delayed: null,
            effect_value: {
              type: 'add',
              value: {
                hop_type: 'custom',
                hop_count: null,
                hop_max_points: 150,
                hop_to_step: '800',
              },
            },
          },
        ],
        last_update: '2025-09-26T22:01:05+0000',
        promotion_type: 'FIDELITY',
        promotion_sub_type: 'LOYALTY_CARD_NEW',
        flow: 'ORDER_SALE',
        promotion_counter: {},
      },
      {
        id: 737,
        id_campaign: 202,
        name: 'Promozione iscrizione fidelity - punti omaggio',
        start_date: '2025-09-02',
        end_date: '2025-09-30',
        lifecycle: 'RUNNING',
        priority: 6,
        combinability: 'ALWAYS',
        effect_type: 'FIDELITY',
        color_code: '#000000',
        title: 'Set permanent points',
        description: 'CHEECK SUB',
        document: '',
        effects: [
          {
            limit: 0,
            name: 'Damme 250',
            application_type: 'AUTO',
            selection: 'none',
            applications: 1,
            value_type: 'POINTS',
            start_date: null,
            end_date: null,
            days_delayed: null,
            effect_value: {
              type: 'single',
              value: '250',
            },
          },
        ],
        last_update: '2025-09-26T22:01:05+0000',
        promotion_type: 'FIDELITY',
        promotion_sub_type: 'LOYALTY_CARD_NEW',
        flow: 'SUBSCRIPTION',
        promotion_counter: {
          current_counter: 0,
          max_counter: 1,
        },
      },
    ],
  },
  {
    id: 216,
    name: 'Prova DT #A',
    start_date: '2025-04-08',
    end_date: '2025-10-30',
    lifecycle: 'RUNNING',
    priority: 211,
    active: 1,
    description: '',
    tags: '',
    cg: {
      legal_entity: 'M013',
      shop_sign: 'DT',
    },
    last_update: '2025-09-26T22:01:02+0000',
    promotions: [
      {
        id: 662,
        id_campaign: 216,
        name: 'Promo cart 10%',
        start_date: '2025-04-08',
        end_date: '2025-10-30',
        lifecycle: 'RUNNING',
        priority: 2,
        combinability: 'ALWAYS',
        effect_type: 'DISCOUNT_SALE',
        color_code: '#FF00FF',
        title: 'Discount sale',
        description: 'Promo cart 10%',
        document: '',
        effects: [
          {
            limit: 0,
            name: '10% sul totale',
            application_type: 'AUTO',
            selection: 'none',
            applications: 1,
            value_type: 'PERCENTAGE',
            start_date: null,
            end_date: null,
            days_delayed: null,
            effect_value: {
              type: 'single',
              value: '-10',
            },
          },
        ],
        last_update: '2025-09-26T22:01:05+0000',
        promotion_type: 'STANDARD',
        promotion_sub_type: '',
        flow: 'STANDARD',
        promotion_counter: {},
      },
      {
        id: 663,
        id_campaign: 216,
        name: 'Promo item 20%',
        start_date: '2025-04-08',
        end_date: '2025-10-30',
        lifecycle: 'RUNNING',
        priority: 1,
        combinability: 'ALWAYS',
        effect_type: 'DISCOUNT',
        color_code: '#00CCFF',
        title: 'Discount',
        description: 'Promo item 20%',
        document: '',
        effects: [
          {
            limit: 0,
            name: '20% su item',
            application_type: 'AUTO',
            selection: 'none',
            applications: 1,
            value_type: 'PERCENTAGE',
            start_date: null,
            end_date: null,
            days_delayed: null,
            effect_value: {
              type: 'single',
              value: '-20',
            },
          },
        ],
        last_update: '2025-09-26T22:01:05+0000',
        promotion_type: 'STANDARD',
        promotion_sub_type: '',
        flow: 'STANDARD',
        promotion_counter: {},
      },
    ],
  },
  {
    id: 227,
    name: 'Promo Fidelity FW25',
    start_date: '2025-08-11',
    end_date: '2025-12-31',
    lifecycle: 'RUNNING',
    priority: 5,
    active: 1,
    description: 'Promozioni Loyalty Intrend per la stagione FW25',
    tags: '',
    cg: {
      legal_entity: 'M013',
      shop_sign: 'DT',
    },
    last_update: '2025-09-26T22:01:02+0000',
    promotions: [
      {
        id: 754,
        id_campaign: 227,
        name: 'Acquista lo sku 91360953060035 --> 15% di sconto',
        start_date: '2025-09-22',
        end_date: '2025-11-30',
        lifecycle: 'RUNNING',
        priority: 2,
        combinability: 'CUMULABLE',
        effect_type: 'DISCOUNT_SALE',
        color_code: '#000000',
        title: 'Discount sale',
        description: 'Acquistando un capo dello sku 91360953060035 ricevi 15%',
        document: '',
        effects: [
          {
            limit: 0,
            name: 'Sconto 15%',
            application_type: 'AUTO',
            selection: 'none',
            applications: 1,
            value_type: 'PERCENTAGE',
            start_date: null,
            end_date: null,
            days_delayed: null,
            effect_value: {
              type: 'single',
              value: '-15',
            },
          },
        ],
        last_update: '2025-09-26T22:01:05+0000',
        promotion_type: 'STANDARD',
        promotion_sub_type: '',
        flow: 'STANDARD',
        promotion_counter: {},
      },
    ],
  },
]

export const DATA_PROMOTIONS_ESTIMATE_RESP = {
  input: {
    config: {},
    shop: {
      retail_code: '0100523',
      shop_country: 'IT',
      shop_sign: 'MC',
    },
    status: 'OPEN',
    code: '169',
    session_code: '0100523-00000169',
    creation_date: '20250825130549',
    request_timestamp: '2025-08-25T13:05:48+0200',
    consumer: {
      consumer_code: '100378388',
      birth_day: '10',
      birth_month: '02',
      birth_year: '1990',
      email: 'loyaltymcpink@qa-support.mmfg.it',
      tel_1: '',
      residence_state: 'IT',
      fidelity: {
        card_type: 'LOYALTY_MC_IT_24',
      },
    },
    payments: [],
    type_cart: 'SALE',
    shipping_method: {},
    items: [
      {
        shop_barcode: '91360953060035',
        id: 1,
        style_code: '9136095306',
        style_code_variant: '9136095306003',
        style_name: 'LIVIO',
        style_variant: '003',
        size: '5',
        year: '2025',
        season: '2',
        class: '13',
        exit: '',
        discount_on_item: 0,
        collection: '693',
        brand: 'IN',
        seasonality: 'SEASONAL',
        product_category: 'GARMENTS',
        retail_price: 90,
        base_price: 90,
        pricelist_type: 'V',
        final_price: 150,
        original_final_price: 90,
        tailor_expenses: 0,
        discount_fidelity: 0,
      },
    ],
    costs: [],
    discount_fidelity: 0,
  },
  rule_engine_version: '20251001084435022191',
  output: [
    {
      code: 'promo_754',
      informations: {
        effect_type: 'DISCOUNT_SALE',
        color_code: '#000000',
        title: 'Discount sale',
        description: 'Acquistando un capo dello sku 91360953060035 ricevi 15%',
      },
      effects: [
        {
          selection: 'none',
          applications: 1,
          value_type: 'PERCENTAGE',
          type: 'CHANGE',
          items: [
            {
              id: 1,
            },
          ],
        },
      ],
      priority: 0,
      cumulability: 'CUMULABLE',
      promotion_counter: {},
    },
    {
      code: 'promo_663',
      informations: {
        effect_type: 'DISCOUNT',
        color_code: '#00CCFF',
        title: 'Discount',
        description: 'Promo item 20%',
      },
      effects: [],
      priority: 1,
      cumulability: 'ALWAYS',
      promotion_counter: {},
    },
    {
      code: 'promo_662',
      informations: {
        effect_type: 'DISCOUNT_SALE',
        color_code: '#FF00FF',
        title: 'Discount sale',
        description: 'Promo cart 10%',
      },
      effects: [],
      priority: 2,
      cumulability: 'ALWAYS',
      promotion_counter: {},
    },
    {
      code: 'promo_523',
      informations: {
        effect_type: 'DISCOUNT_SALE',
        color_code: '#000000',
        title: 'Discount sale',
        description: 'test promo carrello',
      },
      effects: [],
      priority: 3,
      cumulability: 'ALWAYS',
      promotion_counter: {},
    },
    {
      code: 'promo_767',
      informations: {
        effect_type: 'DISCOUNT',
        color_code: '#000000',
        title: 'Discount',
        description: 'Discount',
      },
      effects: [
        {
          selection: 'none',
          applications: 1,
          value_type: 'PERCENTAGE',
          type: 'CHANGE',
          items: [
            {
              id: 1,
            },
          ],
        },
      ],
      priority: 4,
      cumulability: 'ALWAYS',
      promotion_counter: {},
    },
    {
      code: 'promo_750',
      informations: {
        effect_type: 'DISCOUNT_SALE',
        color_code: '#000000',
        title: 'Discount sale',
        description: 'italian desc',
      },
      effects: [
        {
          selection: 'none',
          applications: 1,
          value_type: 'PERCENTAGE',
          type: 'CHANGE',
          items: [
            {
              id: 1,
            },
          ],
        },
      ],
      priority: 5,
      cumulability: 'ALWAYS',
      promotion_counter: {
        current_counter: 0,
        max_counter: 2,
      },
    },
    {
      code: 'promo_751',
      informations: {
        effect_type: 'FIDELITY',
        color_code: '#000000',
        title: 'Set permanent points',
        description: 'Aggiungi 250 punti',
      },
      effects: [],
      priority: 6,
      cumulability: 'ALWAYS',
      promotion_counter: {
        current_counter: 0,
        max_counter: 1,
      },
    },
    {
      code: 'promo_752',
      informations: {
        effect_type: 'DISCOUNT_SALE',
        color_code: '#000000',
        title: 'Discount sale',
        description: 'italian desc',
      },
      effects: [],
      priority: 7,
      cumulability: 'ALWAYS',
      promotion_counter: {},
    },
    {
      code: 'promo_758',
      informations: {
        effect_type: 'FIDELITY',
        color_code: '#000000',
        title: 'Set permanent points',
        description: 'Aggiungo 250 punti permanenti',
      },
      effects: [],
      priority: 8,
      cumulability: 'ALWAYS',
      promotion_counter: {},
    },
    {
      code: 'promo_761',
      informations: {
        effect_type: 'FIDELITY',
        color_code: '#000000',
        title: 'Promo Fid Contatore',
        description: 'Promo di tipi fidelity con contatore',
      },
      effects: [],
      priority: 9,
      cumulability: 'ALWAYS',
      promotion_counter: {
        current_counter: 0,
        max_counter: 3,
      },
    },
    {
      code: 'promo_762',
      informations: {
        effect_type: 'FIDELITY',
        color_code: '#000000',
        title: 'Promo Fid No Cont',
        description: 'Promo di tipi fidelity senza contatore',
      },
      effects: [],
      priority: 10,
      cumulability: 'ALWAYS',
      promotion_counter: {},
    },
    {
      code: 'promo_763',
      informations: {
        effect_type: 'DISCOUNT',
        color_code: '#000000',
        title: 'Sconto normale',
        description: 'Sconto normale in Italiano',
      },
      effects: [],
      priority: 11,
      cumulability: 'ALWAYS',
      promotion_counter: {
        current_counter: 0,
        max_counter: 1,
      },
    },
  ],
  maxed_out_promotions: {},
}
export const DATA_PROMOTIONS_APPLY_RESP = {
  input: {
    config: {
      language: 'it',
      datetime_format: 'FLAT_DATETIME',
    },
    shop: {
      retail_code: '0100523',
      shop_country: 'IT',
      shop_sign: 'DT',
    },
    status: 'OPEN',
    code: '1830',
    session_code: '0100523-1830',
    creation_date: '20251017144522',
    request_timestamp: '2025-10-17T16:57:44+0200',
    consumer: {
      consumer_code: '100377490',
      name: 'ALESSANDRA',
      surname: 'CELENTANO',
      birth_day: '',
      birth_month: '',
      birth_year: '',
      email: 'alessandra.celentano@yopmail.com',
      tel_1: '',
      residence_state: 'IT',
      fidelity: {
        card_type: 'LOYALTY_CARD_NEW',
        card_code: '2130032638297',
        card_real_balance: 5336,
        card_state: 'ENABLED',
        issue_date: '20251015000000',
      },
    },
    payments: [],
    type_cart: 'VENDITA',
    shipping_method: {},
    items: [
      {
        shop_barcode: '91360953060035',
        id: 2,
        style_code: '9136095306',
        style_code_variant: '9136095306003',
        style_name: 'LIVIO',
        style_variant: '003',
        size: '42',
        year: '2025',
        season: '2',
        class: '13',
        exit: '',
        discount_on_item: 0,
        collection: '',
        brand: '',
        seasonality: 'SEASONAL',
        product_category: 'GARMENTS',
        retail_price: 23,
        base_price: 23,
        pricelist_type: 'V',
        final_price: 23,
        original_final_price: 23,
        tailor_expenses: 0,
        discount_fidelity: 0,
      },
      {
        shop_barcode: '82220430050013',
        id: 3,
        style_code: '8222043005',
        style_code_variant: '8222043005001',
        style_name: '2MIMMA',
        style_variant: '001',
        size: '38',
        year: '2023',
        season: '1',
        class: '22',
        exit: '',
        discount_on_item: 0,
        collection: '',
        brand: '',
        seasonality: 'SEASONAL',
        product_category: 'GARMENTS',
        retail_price: 43,
        base_price: 43,
        pricelist_type: 'V',
        final_price: 43,
        original_final_price: 43,
        tailor_expenses: 0,
        discount_fidelity: 0,
      },
    ],
    costs: [],
    discount_fidelity: 0,
  },
  rule_engine_version: '20251017144607189820',
  changes: [
    {
      promo: 'promo_611',
      informations: {
        effect_type: 'DISCOUNT',
        document: '',
        color_code: '#33ff5d',
        title: '15% off scontrini',
        description: 'Promo item test scontrini',
      },
      effects: [
        {
          type: 'CHANGE',
          value_type: 'PERCENTAGE',
          items: [
            {
              id: 2,
              final_price: {
                start: 23,
                end: 19.55,
                diff: -3.45,
              },
              amount_correction: {
                start: null,
                end: -3.45,
              },
              discount_percentage: {
                start: null,
                end: -15,
              },
              amount_correction_th: {
                start: null,
                end: -3.45,
              },
              discount_percentage_th: {
                start: null,
                end: -15,
              },
              partially_applied: false,
              time: '20251017145747.773853ff',
            },
            {
              id: 3,
              final_price: {
                start: 43,
                end: 36.55,
                diff: -6.45,
              },
              amount_correction: {
                start: null,
                end: -6.45,
              },
              discount_percentage: {
                start: null,
                end: -15,
              },
              amount_correction_th: {
                start: null,
                end: -6.45,
              },
              discount_percentage_th: {
                start: null,
                end: -15,
              },
              partially_applied: false,
              time: '20251017145747.773984ff',
            },
          ],
        },
      ],
      promotion_counter: {},
    },
  ],
  errors: [],
  output: {
    config: {
      language: 'it',
      datetime_format: 'FLAT_DATETIME',
    },
    shop: {
      retail_code: '0100523',
      shop_country: 'IT',
      shop_sign: 'DT',
    },
    status: 'OPEN',
    code: '1830',
    session_code: '0100523-1830',
    creation_date: '20251017144522',
    request_timestamp: '2025-10-17T16:57:44+0200',
    consumer: {
      consumer_code: '100377490',
      name: 'ALESSANDRA',
      surname: 'CELENTANO',
      birth_day: '',
      birth_month: '',
      birth_year: '',
      email: 'alessandra.celentano@yopmail.com',
      tel_1: '',
      residence_state: 'IT',
      fidelity: {
        card_type: 'LOYALTY_CARD_NEW',
        card_code: '2130032638297',
        card_real_balance: 5336,
        card_state: 'ENABLED',
        issue_date: '20251015000000',
        IS_VALUED_card_code: true,
      },
      consumer_age: null,
      IS_VALUED_birth_day: false,
      IS_VALUED_birth_month: false,
      IS_VALUED_birth_year: false,
      IS_VALUED_cel_1: false,
      IS_VALUED_consumer_code: true,
      IS_VALUED_email: true,
    },
    payments: [],
    type_cart: 'VENDITA',
    shipping_method: {},
    items: [
      {
        shop_barcode: '91360953060035',
        style_code: '9136095306',
        style_code_variant: '9136095306003',
        style_name: 'LIVIO',
        style_variant: '003',
        size: '42',
        year: '2025',
        season: '2',
        class: '13',
        exit: '',
        discount_on_item: 0,
        collection: '',
        brand: '',
        seasonality: 'SEASONAL',
        product_category: 'GARMENTS',
        retail_price: 23,
        base_price: 23,
        pricelist_type: 'V',
        final_price: 19.55,
        original_final_price: 23,
        tailor_expenses: 0,
        discount_fidelity: 0,
        IS_VALUED_shop_barcode: true,
        amount_correction: -3.45,
        discount_percentage: -15,
        amount_correction_th: -3.45,
        discount_percentage_th: -15,
        promo_engine: ['promo_611'],
        id: 2,
      },
      {
        shop_barcode: '82220430050013',
        style_code: '8222043005',
        style_code_variant: '8222043005001',
        style_name: '2MIMMA',
        style_variant: '001',
        size: '38',
        year: '2023',
        season: '1',
        class: '22',
        exit: '',
        discount_on_item: 0,
        collection: '',
        brand: '',
        seasonality: 'SEASONAL',
        product_category: 'GARMENTS',
        retail_price: 43,
        base_price: 43,
        pricelist_type: 'V',
        final_price: 36.55,
        original_final_price: 43,
        tailor_expenses: 0,
        discount_fidelity: 0,
        IS_VALUED_shop_barcode: true,
        amount_correction: -6.45,
        discount_percentage: -15,
        amount_correction_th: -6.45,
        discount_percentage_th: -15,
        promo_engine: ['promo_611'],
        id: 3,
      },
    ],
    costs: [],
    discount_fidelity: 0,
    day_of_week: null,
    key_legal_entity: 'M013',
    key_shop_sign: 'DT',
  },
  maxed_out_promotions: {},
}

export const DATA_PROMOFIDELITY_ESTIMATE_RESP = {
  input: {
    config: {
      language: 'it',
    },
    type_cart: 'SALE',
    status: 'OPEN',
    shop: {
      retail_code: '0100507',
      shop_country: 'IT',
      shop_sign: 'MA',
    },
    creation_date: '20251018172022',
    shipping_method: {},
    dafcf65c604c4ecaa853df4c47f2b021: false,
    discount_fidelity: 0,
    request_timestamp: '2025-10-18T17:20:22+0000',
    costs: [],
    code: '449295',
    day_of_week: null,
    session_code: '449295',
    consumer: {
      birth_year: '',
      tel_2: '',
      tel_1: '',
      residence_state: 'IT',
      fidelity: {
        issue_date: '',
        expiration_date: '',
        card_level: '',
        card_real_balance: '',
        card_type: 'LOYALTY_CARD_NEW',
        card_code: '',
        card_state: '',
        IS_VALUED_card_code: false,
      },
      consumer_age: null,
      birth_month: '',
      consumer_code: '100235092',
      privacies: [
        {
          flag_marketing: 1,
          flag_privacy: 1,
          brand: 'MA',
        },
      ],
      cel_2: '',
      name: 'FERRANTE',
      cel_1: '',
      vip_level: 0,
      registration_date: '20120420000000',
      surname: 'MARIA',
      mmsp_coupon: 0,
      no_mmsp_coupon: 0,
      email: 'MFERRANTE@YAHOO.COM',
      birth_day: '',
      IS_VALUED_cel_1: false,
    },
    livello_loyalty: '',
    items: [
      {
        season: '1',
        product_category: 'GARMENTS',
        style_variant: '005',
        collection: '31',
        shop_barcode: '30110251020058',
        style_code_variant: '3011025102005',
        final_price: 359.1,
        base_price: 399,
        seasonality: 'SEASONAL',
        style_code: '3011025102',
        discount_fidelity: 0,
        discount_on_item: 0,
        amount_correction: -39.9,
        amount_correction_th: -39.9,
        year: '2025',
        class: '01',
        exit: '',
        style_name: 'TORDO',
        retail_price: 399,
        tailor_expenses: 0,
        size: '8',
        original_final_price: 399,
        pricelist_type: 'V',
        brand: 'MA',
        id: 1,
      },
    ],
    payments: [],
  },
  rule_engine_version: '20251030154057433316',
  output: [
    {
      code: 'promo_796',
      informations: {
        effect_type: 'DISCOUNT_SALE',
        color_code: '#000000',
        title: 'PromoCart A',
        description: '-20% on cart',
        document: '',
      },
      effects: [],
      priority: 0,
      cumulability: 'ALWAYS',
      promotion_counter: {},
    },
    {
      code: 'promo_673',
      informations: {
        effect_type: 'DISCOUNT',
        color_code: '#000000',
        title: 'StepActive A',
        description: '-20% on first item',
        document: '',
      },
      effects: [],
      priority: 1,
      cumulability: 'ALWAYS',
      promotion_counter: {},
    },
    {
      code: 'promo_674',
      informations: {
        effect_type: 'DISCOUNT',
        color_code: '#000000',
        title: 'StepActive B',
        description: '-30% on first two items',
        document: '',
      },
      effects: [],
      priority: 2,
      cumulability: 'ALWAYS',
      promotion_counter: {},
    },
    {
      code: 'promo_675',
      informations: {
        effect_type: 'DISCOUNT',
        color_code: '#000000',
        title: 'StepActive C',
        description: '-30% on last two items',
        document: '',
      },
      effects: [],
      priority: 3,
      cumulability: 'ALWAYS',
      promotion_counter: {},
    },
    {
      code: 'promo_841',
      informations: {
        effect_type: 'DISCOUNT_SALE',
        color_code: '#000000',
        title: 'Discount sale',
        description: 'Tmp Desc',
        document: '',
      },
      effects: [],
      priority: 4,
      cumulability: 'ALWAYS',
      promotion_counter: {},
    },
    {
      code: 'promo_611',
      informations: {
        effect_type: 'DISCOUNT',
        color_code: '#33ff5d',
        title: '15% off scontrini',
        description: 'Promo item test scontrini',
        document: '',
      },
      effects: [],
      priority: 5,
      cumulability: 'CUMULABLE',
      promotion_counter: {},
    },
    {
      code: 'promo_778',
      informations: {
        effect_type: 'DISCOUNT_SALE',
        color_code: '#000000',
        title: 'Sconto se capi > 1',
        description: 'Normale sconto su carrello per prova estimate/evaluate',
        document: '',
      },
      effects: [
        {
          selection: 'none',
          applications: 1,
          value_type: 'PERCENTAGE',
          type: 'CHANGE',
          items: [
            {
              id: 1,
            },
          ],
        },
      ],
      priority: 6,
      cumulability: 'CUMULABLE',
      promotion_counter: {},
    },
    {
      code: 'promo_663',
      informations: {
        effect_type: 'DISCOUNT',
        color_code: '#00CCFF',
        title: 'Discount',
        description: 'Promo item 20%',
        document: '',
      },
      effects: [
        {
          selection: 'none',
          applications: 1,
          value_type: 'PERCENTAGE',
          type: 'CHANGE',
          items: [
            {
              id: 1,
            },
          ],
        },
      ],
      priority: 7,
      cumulability: 'ALWAYS',
      promotion_counter: {},
    },
    {
      code: 'promo_662',
      informations: {
        effect_type: 'DISCOUNT_SALE',
        color_code: '#FF00FF',
        title: 'Discount sale',
        description: 'Promo cart 10%',
        document: '',
      },
      effects: [],
      priority: 8,
      cumulability: 'ALWAYS',
      promotion_counter: {},
    },
    {
      code: 'promo_758',
      informations: {
        effect_type: 'FIDELITY',
        color_code: '#000000',
        title: 'Set permanent points',
        description: 'Aggiungo 250 punti permanenti',
        document: '',
      },
      effects: [
        {
          selection: 'none',
          applications: 1,
          value_type: 'POINTS_PERMANENT',
          type: 'ADD',
          items: [
            {
              id: 1,
            },
          ],
          start_date: '',
          end_date: '',
        },
      ],
      priority: 9,
      cumulability: 'ALWAYS',
      promotion_counter: {},
    },
    {
      code: 'promo_761',
      informations: {
        effect_type: 'FIDELITY',
        color_code: '#000000',
        title: 'Promo Fid Contatore',
        description: 'Promo di tipi fidelity con contatore',
        document: '',
      },
      effects: [
        {
          selection: 'none',
          applications: 1,
          value_type: 'POINTS_PERMANENT',
          type: 'ADD',
          items: [
            {
              id: 1,
            },
          ],
          start_date: '',
          end_date: '',
        },
      ],
      priority: 10,
      cumulability: 'CUMULABLE',
      promotion_counter: {
        current_counter: 0,
        max_counter: 100,
      },
    },
    {
      code: 'promo_762',
      informations: {
        effect_type: 'FIDELITY',
        color_code: '#000000',
        title: 'Promo Fid No Cont',
        description: 'Promo di tipi fidelity senza contatore',
        document: '',
      },
      effects: [
        {
          selection: 'none',
          applications: 1,
          value_type: 'POINTS_PERMANENT',
          type: 'ADD',
          items: [
            {
              id: 1,
            },
          ],
          start_date: '',
          end_date: '',
        },
      ],
      priority: 11,
      cumulability: 'CUMULABLE',
      promotion_counter: {},
    },
    {
      code: 'promo_763',
      informations: {
        effect_type: 'DISCOUNT',
        color_code: '#000000',
        title: 'Sconto normale',
        description: 'Sconto normale in Italiano',
        document: '',
      },
      effects: [
        {
          selection: 'none',
          applications: 1,
          value_type: 'PERCENTAGE',
          type: 'CHANGE',
          items: [
            {
              id: 1,
            },
          ],
        },
      ],
      priority: 12,
      cumulability: 'CUMULABLE',
      promotion_counter: {
        current_counter: 0,
        max_counter: 1,
      },
    },
  ],
  maxed_out_promotions: {
    promo_999: {
      current_counter: 1,
      max_counter: 1,
    },
    promo_1000: {
      current_counter: 3,
      max_counter: 3,
    },
  },
}

export const DATA_PROMOFIDELITY_APPLY_RESP = {
  input: {
    config: {
      language: 'it',
    },
    type_cart: 'SALE',
    status: 'OPEN',
    shop: {
      retail_code: '0100507',
      shop_country: 'IT',
      shop_sign: 'MA',
    },
    creation_date: '20251018172022',
    shipping_method: {},
    dafcf65c604c4ecaa853df4c47f2b021: false,
    discount_fidelity: 0,
    request_timestamp: '2025-10-18T17:20:22+0000',
    costs: [],
    code: '449295',
    day_of_week: null,
    session_code: '449295',
    consumer: {
      birth_year: '',
      tel_2: '',
      tel_1: '',
      residence_state: 'IT',
      fidelity: {
        issue_date: '',
        expiration_date: '',
        card_level: '',
        card_real_balance: '',
        card_type: 'LOYALTY_CARD_NEW',
        card_code: '',
        card_state: '',
        IS_VALUED_card_code: false,
      },
      consumer_age: null,
      birth_month: '',
      consumer_code: '100235092',
      privacies: [
        {
          flag_marketing: 1,
          flag_privacy: 1,
          brand: 'MA',
        },
      ],
      cel_2: '',
      name: 'FERRANTE',
      cel_1: '',
      vip_level: 0,
      registration_date: '20120420000000',
      surname: 'MARIA',
      mmsp_coupon: 0,
      no_mmsp_coupon: 0,
      email: 'MFERRANTE@YAHOO.COM',
      birth_day: '',
      IS_VALUED_cel_1: false,
    },
    livello_loyalty: '',
    items: [
      {
        season: '1',
        product_category: 'GARMENTS',
        style_variant: '005',
        collection: '31',
        shop_barcode: '30110251020058',
        style_code_variant: '3011025102005',
        final_price: 359.1,
        base_price: 399,
        seasonality: 'SEASONAL',
        style_code: '3011025102',
        discount_fidelity: 0,
        discount_on_item: 0,
        amount_correction: -39.9,
        amount_correction_th: -39.9,
        year: '2025',
        class: '01',
        exit: '',
        style_name: 'TORDO',
        retail_price: 399,
        tailor_expenses: 0,
        size: '8',
        original_final_price: 399,
        pricelist_type: 'V',
        brand: 'MA',
        id: 1,
      },
    ],
    payments: [],
  },
  rule_engine_version: '20251030154057433316',
  changes: [
    {
      promo: 'promo_778',
      informations: {
        effect_type: 'DISCOUNT_SALE',
        document: '',
        color_code: '#000000',
        title: 'Sconto se capi > 1',
        description: 'Normale sconto su carrello per prova estimate/evaluate',
      },
      effects: [
        {
          type: 'CHANGE',
          value_type: 'PERCENTAGE',
          items: [
            {
              id: 1,
              final_price: {
                start: 359.1,
                end: 223.44,
                diff: -135.66,
              },
              amount_correction: {
                start: -39.9,
                end: -175.56,
                diff: -135.66,
              },
              discount_percentage: {
                start: null,
                end: -40.0,
              },
              amount_correction_th: {
                start: -39.9,
                end: -175.56,
                diff: -135.66,
              },
              discount_percentage_th: {
                start: null,
                end: -40.0,
              },
              partially_applied: false,
              time: '20251030161247.140304ff',
            },
          ],
        },
      ],
      promotion_counter: {},
    },
    {
      promo: 'promo_761',
      informations: {
        effect_type: 'FIDELITY',
        document: '',
        color_code: '#000000',
        title: 'Promo Fid Contatore',
        description: 'Promo di tipi fidelity con contatore',
      },
      effects: [
        {
          type: 'ADD',
          value_type: 'POINTS_PERMANENT',
          start_date: '',
          end_date: '',
          items: [
            {
              id: 1,
              value: 300.0,
            },
          ],
        },
      ],
      promotion_counter: {
        current_counter: 0,
        max_counter: 100,
      },
    },
  ],
  errors: [],
  output: {
    config: {
      language: 'it',
    },
    type_cart: 'SALE',
    status: 'OPEN',
    shop: {
      retail_code: '0100507',
      shop_country: 'IT',
      shop_sign: 'MA',
    },
    creation_date: '20251018172022',
    shipping_method: {},
    discount_fidelity: 0,
    request_timestamp: '2025-10-18T17:20:22+0000',
    costs: [],
    code: '449295',
    day_of_week: 6,
    session_code: '449295',
    consumer: {
      birth_year: '',
      tel_2: '',
      tel_1: '',
      residence_state: 'IT',
      fidelity: {
        issue_date: '',
        expiration_date: '',
        card_level: '',
        card_real_balance: '',
        card_type: 'LOYALTY_CARD_NEW',
        card_code: '',
        card_state: '',
        IS_VALUED_card_code: false,
      },
      consumer_age: null,
      birth_month: '',
      consumer_code: '100235092',
      privacies: [
        {
          flag_marketing: 1,
          flag_privacy: 1,
          brand: 'MA',
        },
      ],
      cel_2: '',
      name: 'FERRANTE',
      cel_1: '',
      vip_level: 0,
      registration_date: '20120420000000',
      surname: 'MARIA',
      mmsp_coupon: 0,
      no_mmsp_coupon: 0,
      email: 'MFERRANTE@YAHOO.COM',
      birth_day: '',
      IS_VALUED_cel_1: false,
      IS_VALUED_birth_day: false,
      IS_VALUED_birth_month: false,
      IS_VALUED_birth_year: false,
      IS_VALUED_consumer_code: true,
      IS_VALUED_email: true,
    },
    livello_loyalty: '',
    items: [
      {
        season: '1',
        product_category: 'GARMENTS',
        style_variant: '005',
        collection: '31',
        shop_barcode: '30110251020058',
        style_code_variant: '3011025102005',
        final_price: 223.44,
        base_price: 399,
        seasonality: 'SEASONAL',
        style_code: '3011025102',
        discount_fidelity: 0,
        discount_on_item: 0,
        amount_correction: -175.56,
        amount_correction_th: -175.56,
        year: '2025',
        class: '01',
        exit: '',
        style_name: 'TORDO',
        retail_price: 399,
        tailor_expenses: 0,
        size: '8',
        original_final_price: 399,
        pricelist_type: 'V',
        brand: 'MA',
        IS_VALUED_shop_barcode: true,
        discount_percentage: -40.0,
        discount_percentage_th: -40.0,
        fidelity_points: 224.0,
        promo_engine: ['promo_778', 'promo_761'],
        promo_engine_points: [
          {
            promo_id: 'promo_761',
            value: 300.0,
            type: 'PERMANENT',
            start_date: '',
            end_date: '',
          },
        ],
        id: 1,
      },
    ],
    payments: [],
    key_legal_entity: 'M013',
    key_shop_sign: 'DT',
  },
  maxed_out_promotions: {},
}
/**
 * Provides a mock implementation of the PromoEngineApi's `apiV1PromoEngineV2ListGet` method,
 * which returns a Promise that resolves to a `GetPromoEnginePromotionList` object after a 1 second delay.
 * @returns {AxiosPromise<GetPromoEnginePromotionList>} A Promise that resolves to a `GetPromoEnginePromotionList` object.
 */
export const mockPromoEngineApi: ReturnType<typeof PromoEngineApiFactory> = {
  // Liscia
  // apiV1PromoEngineV2ListGet(): AxiosPromise<GetPromoEnginePromotionList> {
  //   return Promise.resolve({
  //     data: {
  //       data: DATA_PROMOTIONS_RESP,
  //     },
  //   }) as AxiosPromise<GetPromoEnginePromotionList>
  // },

  // Con delay
  apiV1PromoEngineV2ListGet(): AxiosPromise<GetPromoEnginePromotionList> {
    return new Promise((resolve) => {
      setTimeout(() => {
        resolve({
          data: {
            data: DATA_PROMOTIONS_RESP,
          },
          status: 200,
          statusText: 'OK',
          headers: {},
          config: {},
        })
      }, 1000)
    }) as AxiosPromise<GetPromoEnginePromotionList>
  },

  apiV1AbstridPromoV1CampaignsGet(): AxiosPromise<InlineResponse2007> {
    return new Promise((resolve) => {
      setTimeout(() => {
        resolve({
          data: {
            data: DATA_CAMPAIGNS_RESP,
          },
          status: 200,
          statusText: 'OK',
          headers: {},
          config: {},
        })
      }, 1000)
    }) as AxiosPromise<InlineResponse2007>
  },

  apiV1AbstridPromoV1EstimatePost(): AxiosPromise<InlineResponse2006> {
    return new Promise((resolve) => {
      setTimeout(() => {
        resolve({
          // data: DATA_PROMOTIONS_ESTIMATE_RESP as unknown as InlineResponse2006,
          data: DATA_PROMOFIDELITY_ESTIMATE_RESP as unknown as InlineResponse2006,
          status: 200,
          statusText: 'OK',
          headers: {},
          config: {},
        })
      }, 1000)
    }) as AxiosPromise<InlineResponse2006>
  },

  apiV1AbstridPromoV1ApplyPost(): AxiosPromise<InlineResponse2006> {
    return new Promise((resolve) => {
      setTimeout(() => {
        resolve({
          // data: DATA_PROMOTIONS_APPLY_RESP as unknown as InlineResponse2006,
          data: DATA_PROMOFIDELITY_APPLY_RESP as unknown as InlineResponse2006,
          status: 200,
          statusText: 'OK',
          headers: {},
          config: {},
        })
      }, 1000)
    }) as AxiosPromise<InlineResponse2006>
  },

  apiV1AbstridPromoV1FidelityUpdatePatch(): AxiosPromise<InlineResponse20014> {
    return new Promise((resolve) => {
      setTimeout(() => {
        resolve({
          // data: DATA_PROMOTIONS_APPLY_RESP as unknown as InlineResponse2006,
          data: FIDELITY_UPDATE_PAYLOAD as unknown as InlineResponse20014,
          status: 200,
          statusText: 'OK',
          headers: {},
          config: {},
        })
      }, 1000)
    }) as AxiosPromise<InlineResponse20014>
  },
}

// MOCK not applicable elements
export const NON_APPLICABLE_PROMOS = [
  {
    id: 9001,
    id_campaign: 999,
    name: 'TEST – Non applicabile 1',
    start_date: '2025-01-01',
    end_date: '2025-12-31',
    lifecycle: 'EXPIRED',
    priority: 9999,
    combinability: 'ALWAYS',
    effect_type: 'DISCOUNT',
    color_code: '#888888',
    title: 'Test NA 1',
    description: 'Solo per test UI (non applicabile)',
    document: '',
    effects: [],
    last_update: new Date().toISOString(),
    promotion_type: 'STANDARD',
    promotion_sub_type: '',
    flow: 'STANDARD',
    campagna: 'Test suite',
    priority_idx: 9999,
  },
  {
    id: 9002,
    id_campaign: 999,
    name: 'TEST – Non applicabile 2',
    start_date: '2025-01-01',
    end_date: '2025-12-31',
    lifecycle: 'EXPIRED',
    priority: 9998,
    combinability: 'CUMULABLE',
    effect_type: 'DISCOUNT',
    color_code: '#777777',
    title: 'Test NA 2',
    description: 'Solo per test UI (non applicabile)',
    document: '',
    effects: [],
    last_update: new Date().toISOString(),
    promotion_type: 'STANDARD',
    promotion_sub_type: '',
    flow: 'STANDARD',
    campagna: 'Test suite',
    priority_idx: 9998,
  },
] as GetPromoEnginePromotionList[]

// MOCK per la richiesta ESTIMATE (payload)
export const MANUAL_ESTIMATE_PAYLOAD = {
  config: {
    language: 'en',
    datetime_format: 'FLAT_DATETIME',
  },
  shop: {
    retail_code: '0100523',
    shop_country: 'IT',
    shop_sign: 'MC',
  },
  status: 'OPEN',
  code: '169',
  session_code: '0100523-00000169',
  creation_date: '20250825130549',
  request_timestamp: '2025-08-25T13:05:48+0200',
  consumer: {
    consumer_code: '100378388', // REQUIRED
    // name: 'name',
    // surname: 'PINK',
    birth_day: '10', // REQUIRED
    birth_month: '02', // REQUIRED
    birth_year: '1990', // REQUIRED
    email: 'loyaltymcpink@qa-support.mmfg.it', // REQUIRED
    tel_1: '',
    // tel_2: '',
    // cel_1: '',
    // cel_2: '',
    residence_state: 'IT',
    fidelity: {
      card_type: 'LOYALTY_MC_IT_24', // REQUIRED
      // card_code: '3030022375586',
      // card_level: 'RED',
      // card_real_balance: 3024,
      // card_state: 'ENABLED',
      // issue_date: '20240209000000',
      // expiration_date: '',
    },
    // privacies: [
    //   {
    //     brand: 'MC',
    //     flag_privacy: 1,
    //     flag_marketing: 1,
    //   },
    // ],
    // registration_date: '20240209000000',
    // mmsp_coupon: 0,
    // no_mmsp_coupon: 0,
    // vip_level: 0,
  },
  payments: [],
  type_cart: 'SALE',
  shipping_method: {},
  items: [
    {
      shop_barcode: '91360953060035',
      id: 1,
      style_code: '9136095306',
      style_code_variant: '9136095306003',
      style_name: 'LIVIO',
      style_variant: '003',
      size: '5',
      year: '2025',
      season: '2',
      class: '13',
      exit: '',
      discount_on_item: 0,
      collection: '693',
      brand: 'IN',
      seasonality: 'SEASONAL',
      product_category: 'GARMENTS',
      retail_price: 90,
      base_price: 90,
      pricelist_type: 'V',
      final_price: 150.0,
      original_final_price: 90,
      tailor_expenses: 0,
      discount_fidelity: 0.0,
    },
  ],
  costs: [],
  discount_fidelity: 0,
}
export const MANUAL_APPLY_PAYLOAD = {
  input: {
    config: {},
    shop: {
      retail_code: '0100095',
      shop_country: 'IT',
      shop_sign: 'MC',
    },
    status: 'OPEN',
    code: '169',
    session_code: '0100095-00000169',
    creation_date: '20250825130549',
    request_timestamp: '2025-08-25T13:05:48+0200',
    consumer: {
      consumer_code: '100378388',
      name: 'name',
      surname: 'PINK',
      birth_day: '10',
      birth_month: '02',
      birth_year: '1990',
      email: 'loyaltymcpink@qa-support.mmfg.it',
      tel_1: '',
      tel_2: '',
      cel_1: '',
      cel_2: '',
      residence_state: 'IT',
      fidelity: {
        card_type: 'LOYALTY_MC_IT_24',
        card_code: '3030022375586',
        card_level: 'RED',
        card_real_balance: 3024,
        card_state: 'ENABLED',
        issue_date: '20240209000000',
        expiration_date: '',
      },
      privacies: [
        {
          brand: 'MC',
          flag_privacy: 1,
          flag_marketing: 1,
        },
      ],
      registration_date: '20240209000000',
      mmsp_coupon: 0,
      no_mmsp_coupon: 0,
      vip_level: 0,
    },
    payments: [],
    type_cart: 'SALE',
    shipping_method: {},
    items: [
      {
        shop_barcode: '69710151020022',
        id: 1,
        style_code: '6971015102',
        style_code_variant: '6971015102002',
        style_name: 'ORIONE',
        style_variant: '002',
        size: '2',
        year: '2025',
        season: '1',
        class: '97',
        exit: '',
        discount_on_item: 0,
        collection: '61',
        brand: 'MC',
        seasonality: 'SEASONAL',
        product_category: 'GARMENTS',
        retail_price: 99,
        base_price: 99,
        pricelist_type: 'V',
        final_price: 99.0,
        original_final_price: 99,
        tailor_expenses: 0,
        discount_fidelity: 0.0,
      },
    ],
    costs: [],
    discount_fidelity: 0,
  },
  rule_engine_version: '20250908091859263766',
  output: [
    {
      code: 'promo_691',
      informations: {
        effect_type: 'DISCOUNT',
        color_code: '#000000',
        title: 'Discount',
        description: 'bugfix abstrid',
      },
      effects: [
        {
          selection: 'none',
          applications: 1,
          items: [
            {
              id: 1,
            },
          ],
        },
      ],
      priority: 0,
      cumulability: 'ALWAYS',
      promotion_counter: {},
    },
    {
      code: 'promo_704',
      informations: {
        effect_type: 'DISCOUNT',
        color_code: '#015FB4',
        title: 'Sconto Progressivo',
        description: '10% sul 2° / 20% sul 3° / 30% dal 4°',
      },
      effects: [],
      priority: 1,
      cumulability: 'CUMULABLE',
      promotion_counter: {},
    },
    {
      code: 'promo_705',
      informations: {
        effect_type: 'DISCOUNT',
        color_code: '#000000',
        title: 'Discount',
        description: 'Promozione % ad item',
      },
      effects: [],
      priority: 2,
      cumulability: 'ALWAYS',
      promotion_counter: {},
    },
    {
      code: 'promo_679',
      informations: {
        effect_type: 'DISCOUNT',
        color_code: '#000000',
        title: 'Discount',
        description: '10%',
      },
      effects: [],
      priority: 3,
      cumulability: 'EXCLUSIVE',
      promotion_counter: {},
    },
    {
      code: 'promo_689',
      informations: {
        effect_type: 'DISCOUNT_SALE',
        color_code: '#000000',
        title: 'Discount sale',
        description: 'Sample Sale',
      },
      effects: [],
      priority: 4,
      cumulability: 'ALWAYS',
      promotion_counter: {},
    },
  ],
  maxed_out_promotions: {},
  promotions: [
    {
      promo: 'promo_831',
      effects: [
        {
          selection: 'none',
          applications: 1,
          items: [
            {
              id: 1,
            },
          ],
        },
      ],
    },
    {
      promo: 'promo_495',
      effects: [
        {
          selection: 'none',
          applications: 1,
          items: [
            {
              id: 1,
            },
          ],
        },
      ],
    },
  ],
}

export const FIDELITY_UPDATE_PAYLOAD = {
  data: {
    operation: 'SALE',
    shop_code: '0133007',
    total_sale: 258.0,
    currency: 'EUR',
    pk_consumer: '100401273',
    operation_datetime: '2025-10-02 17:54:56',
    capi: [
      {
        progressivo: 1,
        sku: '63660741060094',
        tipo_prezzo: 'V',
        importo_iniziale: 150.0,
        importo_finale: 150.0,
        classe: '',
        annostag: '',
        modello: '6366074106',
        variante: '009',
        taglia: '4',
      },
      {
        progressivo: 2,
        sku: '11365451050607',
        tipo_prezzo: 'V',
        importo_iniziale: 118.0,
        importo_finale: 118.0,
        classe: '',
        annostag: '',
        modello: '1136545105',
        variante: '060',
        taglia: '7',
      },
    ],
    contabilita: [
      {
        codice_movimento: 'CONTABILITA_PROMOZIONE',
        importo_finale: -25,
        codice: '2130032381438',
        tipo: 'LOYALTY_CARD_NEW',
        punti: '-550',
      },
    ],
    pagamenti: [
      {
        cod_operazione: '',
        importo_finale: 258.0,
      },
    ],
    user: 'balbag',
    operation_id: 'test_sale_1',
    handle_duplicates: 1,
  },
}
